import { useLumpsumPlansContext } from '../../LumpsumPlansProvider'
import { LockedBlurredListOverlay, LockedEmptyUpsell } from '../shared/LockedPlanPieces'
import { RebalanceCategoryList } from './RebalanceCategoryList'
import { REBALANCE_BLURRED_CATEGORIES } from '../../../../../mock/data/blurFixtures'

/**
 * PLAN_ROLLED_OUT but not Elite — blur list + unlock, or empty top-shape upsell.
 */
export function RebalanceBlurredBody() {
  const { rebalancePlansData } = useLumpsumPlansContext()
  const sellFundCount = rebalancePlansData?.sellFundCount ?? 0
  const buyFundCount = rebalancePlansData?.buyFundCount ?? 0
  const underReviewFundCount = rebalancePlansData?.underReviewFundCount ?? 0
  const hasLockedListContent = sellFundCount + buyFundCount + underReviewFundCount > 0

  if (!hasLockedListContent) {
    return (
      <LockedEmptyUpsell
        icon="rebalance"
        copy="Get Monthly Rebalance Plan,<br />Power Rank, Trends and a lot more."
        buttonLabel="Unlock with Elite"
      />
    )
  }

  return (
    <LockedBlurredListOverlay
      message={
        <>
          Your rebalance plan is
          <br />
          currently locked
        </>
      }
      buttonLabel="Unlock with Elite"
    >
      <RebalanceCategoryList categories={REBALANCE_BLURRED_CATEGORIES} />
    </LockedBlurredListOverlay>
  )
}
